import AppController from './client/app-controller'

AppController()
